import React from 'react';

import { IconPayPalFastlane } from '@bigcommerce/checkout/ui';

import './PoweredByPayPalFastlaneLabel.scss';

const PoweredByPayPalFastlaneLabel = () => (
    <div className="powered-by-paypal-fastlane" data-test="paypal-fastlane-icon">
        <IconPayPalFastlane />
    </div>
);

export default PoweredByPayPalFastlaneLabel;
